import { Button, Kind, Size } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { ReactComponent as GamesIcon } from 'assets/images/ic-games.svg'
import { ReactComponent as PhoneIcon } from 'assets/images/ic-phone.svg'
import { buildTranslate } from 'locales'
import { merchantTheme } from 'theme'
import { integrationsCenterUrls } from 'utilities/urlUtils'

const t = buildTranslate('games')

const GamesCallToAction = () => {
  const { colors } = merchantTheme

  const handleLearnMore = () => {
    window.open(integrationsCenterUrls.help, '_blank')
  }

  const handleContactUs = () => {
    window.open(
      'mailto:merchant.support@thanx.com?subject=I%20would%20like%20to%20enable%20Brame%20for%20gamification',
      '_self'
    )
  }

  return (
    <div
      className="p-l rounded-1 border border-1"
      style={{
        backgroundColor: colors.grey10,
        borderColor: colors.grey20,
      }}
    >
      <div className="d-flex align-items-center mb-m">
        <div className="me-xs" style={{ color: colors.grey70 }}>
          <PhoneIcon width={24} height={24} />
        </div>
        <Text.BodyText3 color={colors.grey70} className="fs-4 fw-bold mx-xxs">
          +
        </Text.BodyText3>
        <div style={{ color: colors.grey70 }}>
          <GamesIcon width={30} height={24} />
        </div>
      </div>

      <div className="mb-l">
        <Text.Header4 className="mb-xs">{t('disabled.cta.title')}</Text.Header4>
        <Text.BodyText3 color={colors.grey70}>
          {t('disabled.cta.description')}
        </Text.BodyText3>
      </div>

      <div className="d-flex justify-content-end" style={{ gap: '16px' }}>
        <Button
          kind={Kind.SECONDARY}
          size={Size.STANDARD}
          onClick={handleLearnMore}
        >
          {t('disabled.cta.learnMore')}
        </Button>
        <Button
          kind={Kind.PRIMARY}
          size={Size.STANDARD}
          onClick={handleContactUs}
        >
          {t('disabled.cta.contact')}
        </Button>
      </div>
    </div>
  )
}

export default GamesCallToAction
